// About.jsx - Full About Page
import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-6xl mx-auto px-6">
          {/* Header */}
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-wide">
              ABOUT <span className="italic text-teal-600">the artist</span>
            </h1>
            <div className="flex items-center justify-center mb-8">
              <div className="w-16 h-px bg-teal-500"></div>
              <div className="w-2 h-2 bg-teal-500 rounded-full mx-4"></div>
              <div className="w-16 h-px bg-teal-500"></div>
            </div>
          </div>

          {/* Main Content */}
          <div className="grid md:grid-cols-2 gap-16 items-start mb-16">
            <div>
              <img
                src="https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763411201/SSK_7159_yerbgi.jpg"
                alt="About the photographer"
                className="w-full h-auto object-cover rounded-lg shadow-xl"
              />
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-light text-gray-900 mb-6">
                Welcome to Shasz Studios
              </h2>
              <p className="text-gray-600 mb-6 font-light leading-relaxed">
                At Shasz Studios, we focus on capturing the essence of life's most
                beautiful moments, blending artistry and storytelling in every
                frame. With a deep passion for creating timeless images, I
                specialize in lifestyle portraits, weddings, and landscapes.
              </p>
              <p className="text-gray-600 mb-6 font-light leading-relaxed">
                Each photograph is crafted to reflect emotion and natural beauty,
                ensuring that your memories are preserved with authenticity and
                elegance. Whether it's a couple's intimate connection, the joy of
                a wedding day, or the serene beauty of a landscape, I am dedicated
                to delivering images that tell your unique story.
              </p>
              <p className="text-gray-600 mb-6 font-light leading-relaxed">
                Photography is more than just a profession for me—it's a way of
                seeing the world. I believe that every moment, no matter how small,
                has the potential to become something extraordinary when captured
                through the right lens. My approach combines technical expertise
                with a genuine love for storytelling, ensuring that each image
                resonates with emotion and meaning.
              </p>
            </div>
          </div>

          {/* My Approach Section */}
          <div className="mb-16">
            <h2 className="text-2xl md:text-3xl font-light text-gray-900 mb-8 text-center">
              My <span className="italic text-teal-600">Approach</span>
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-light text-gray-900 mb-3">Authentic Moments</h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  I focus on capturing genuine emotions and natural interactions,
                  creating images that feel real and timeless.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-light text-gray-900 mb-3">Personal Connection</h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  Building a comfortable relationship with my clients ensures
                  relaxed, natural photos that truly reflect their personality.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-xl font-light text-gray-900 mb-3">Creative Vision</h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  Every session is approached with fresh creativity, ensuring
                  unique and artistic images tailored to your story.
                </p>
              </div>
            </div>
          </div>

          {/* More About Me */}
          <div className="bg-gray-50 rounded-lg p-8 md:p-12">
            <h2 className="text-2xl md:text-3xl font-light text-gray-900 mb-8 text-center">
              More <span className="italic text-teal-600">About Me</span>
            </h2>
            <div className="max-w-3xl mx-auto space-y-6">
              <p className="text-gray-600 font-light leading-relaxed">
                I'm an Indian-rooted photographer who has called the Netherlands home for over a decade. 
                By profession, I work as an IT professional in the financial services industry, but my 
                heart truly belongs to the world of photography.
              </p>
              <p className="text-gray-600 font-light leading-relaxed">
                My journey behind the lens began with a deep admiration for natural landscapes. There's 
                something magical about capturing nature at its most breathtaking moments—the golden hour 
                light dancing across fields, dramatic skies at sunset, or the quiet stillness of early 
                morning mist. This passion drove me to learn everything I could about photography.
              </p>
              <p className="text-gray-600 font-light leading-relaxed">
                Over time, my curiosity expanded into portraits and studio lighting, but my roots in 
                landscape photography continue to influence my work. You'll notice that my images often 
                incorporate natural elements—whether it's the soft glow of outdoor light, scenic 
                backdrops, or the organic beauty of the environment.
              </p>
              <p className="text-gray-600 font-light leading-relaxed">
                If you share my love for landscapes, I invite you to visit my{" "}
                <a 
                  href="https://www.instagram.com/shameem88" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#548e9b] hover:underline"
                >
                  <FaInstagram className="inline align-middle mr-1" />
                  <span className="align-middle">Instagram page</span>
                </a>{" "}
                where I share more of my landscape work. Your support means the world to me, and I'm 
                grateful for every person who joins me on this creative journey.
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center mt-16">
            <h2 className="text-2xl md:text-3xl font-light text-gray-900 mb-6">
              Let's Create <span className="italic text-teal-600">Together</span>
            </h2>
            <p className="text-gray-600 font-light leading-relaxed mb-8 max-w-2xl mx-auto">
              I'd love to hear about your vision and help bring your story to life
              through beautiful, timeless photography. Get in touch to discuss your
              next session.
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
              <Link
                to="/book-now"
                className="group/btn relative overflow-hidden bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white duration-150 w-full sm:w-[200px] rounded-md font-light px-6 py-3 tracking-widest text-sm uppercase transition-all transform hover:shadow-lg hover:scale-105"
              >
                <span className="relative z-10">Book a Session</span>
                <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-teal-500 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-500"></div>
              </Link>
              <Link
                to="/portfolio"
                className="group/btn relative overflow-hidden bg-white border-2 border-teal-500 text-teal-600 hover:bg-teal-50 duration-150 w-full sm:w-auto rounded-md font-light px-6 py-3 tracking-widest text-sm uppercase transition-all transform hover:shadow-lg hover:scale-105 whitespace-nowrap"
              >
                <span className="relative z-10">View Portfolio</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
